import { createDebugConsoleOverlay } from "./debugConsoleOverlay";
import StartGame from "./game/main";

const params = new URLSearchParams(typeof window !== "undefined" ? window.location.search : "");
const debugConsoleParam = params.get("debugConsole");
const disableDebugConsole =
  params.has("noDebugConsole") ||
  (debugConsoleParam !== null && /^(0|false|off)$/i.test(debugConsoleParam));

if (!disableDebugConsole) {
  createDebugConsoleOverlay();
}

document.addEventListener("DOMContentLoaded", () => {
  StartGame("game-container");
});
